import React from 'react';
import {shape, arrayOf, string, object, any, bool} from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router-dom';
import {Table, Icon, Container} from 'semantic-ui-react';
import {formatDate} from 'utils/DBUtils';
import FailureDisplay from './FailureDisplay';

const UserRafflesPage = props => {
  if (props.isLoading) {
    return (
      <Container textAlign='center'>
        <Icon loading name='spinner' size='huge' />
      </Container>
    );
  }

  if (props.ajaxError) {
    return <FailureDisplay labelKey='userManagement.userDetail.panes.raffles.ajaxError' />;
  }

  return props.raffleEntries.length === 0 ? (
    <p><FormattedMessage id='userManagement.userDetail.panes.raffles.empty' /></p>
  ) : (
    <Table striped>
      <Table.Header className='white-header'>
        <Table.HeaderCell></Table.HeaderCell>
        <Table.HeaderCell>
          <FormattedMessage id='userManagement.userDetail.panes.raffles.raffleId' />
        </Table.HeaderCell>
        <Table.HeaderCell>
          <FormattedMessage id='userManagement.userDetail.panes.raffles.prizeTitle' />
        </Table.HeaderCell>
        <Table.HeaderCell>
          <FormattedMessage id='userManagement.userDetail.panes.raffles.dateCreated' />
        </Table.HeaderCell>
        <Table.HeaderCell>
          <FormattedMessage id='userManagement.userDetail.panes.raffles.winner' />
        </Table.HeaderCell>
      </Table.Header>
      <Table.Body>
        {props.raffleEntries.map(entry => (
          <Table.Row>
            <Table.Cell>
              <Link to={`https://www.dailybreak.com/prizebooth/raffle/${entry.raffleId}`} target='_blank'>
                <Icon name='search' />
              </Link>
            </Table.Cell>
            <Table.Cell>{entry.raffleId}</Table.Cell>
            <Table.Cell>{entry.prizeTitle}</Table.Cell>
            <Table.Cell>{entry.dateCreated ? formatDate(entry.dateCreated) : ''}</Table.Cell>
            <Table.Cell>{String(Boolean(entry.winner))}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export const RaffleEntryPropType = shape({
  raffleId: any,
  prizeTitle: string,
  dateCreated: object
});

UserRafflesPage.propTypes = {
  raffleEntries: arrayOf(RaffleEntryPropType),
  isLoading: bool.isRequired,
  ajaxError: object
};

export default UserRafflesPage;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/tabPanes/UserRafflesPage.jsx